<div id="new-employee-wrapper" data-cy="new-employee-wrapper">
  <ep-employee-form-card
    mode="add"
    [isSaving]="isSaving"
    [isSaveDisabled]="(isSaveDisabled$ | async) === true || !locations.length"
    (save)="saveEmployee()"
  >
    <app-employee-form></app-employee-form>
  </ep-employee-form-card>
</div>
